import { Input } from '@/components/atoms/Form/Input';
import { Control, Controller, Form, useForm } from 'react-hook-form';
import React from 'react';
import { computeText } from '@/locales/utils';
import { useIntl } from 'react-intl';
import { useCreateLoyaltyConfigMutation } from '@/services/innovorder/modules/modules.endpoints';

interface ComoConfigCreateFormProps {
    control: Control<{ comoApiKey: string }>;
    canChangeProvider: boolean;
    createError: boolean;
}

const ComoConfigCreateForm = ({ control, canChangeProvider, createError }: ComoConfigCreateFormProps) => {
    const intl = useIntl();
    return (
        <Form control={control}>
            <Controller
                control={control}
                name="comoApiKey"
                rules={{
                    required: computeText(intl, 'field.required'),
                    validate: (value) => value && (canChangeProvider || computeText(intl, 'como.error.changeProvider')),
                }}
                render={({ field, fieldState }) => (
                    <Input
                        {...field}
                        labelId="como.apiKey"
                        placeholder="como.apiKey.placeholder"
                        error={
                            fieldState.error?.message ||
                            (createError ? computeText(intl, 'como.error.invalidApiKey') : undefined)
                        }
                    />
                )}
            />
        </Form>
    );
};

export default ComoConfigCreateForm;
